"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var React = require("react");
var Card_styles_1 = require("./Card.styles");
var Card = function (_a) {
    var Title = _a.Title, SubTitle = _a.SubTitle, Detail = _a.Detail, Button = _a.Button, children = _a.children;
    return (React.createElement(Card_styles_1.WrapperDiv, null,
        React.createElement(Card_styles_1.TitleWrapperDiv, null,
            React.createElement(Card_styles_1.TitleTextH2, null, Title),
            React.createElement(Card_styles_1.ButtonWrapperDiv, null, Button && Button()),
            React.createElement(Card_styles_1.SubTitleTextP, null, SubTitle)),
        Detail && React.createElement(Card_styles_1.DetailTextP, null, Detail),
        React.createElement(Card_styles_1.ContentDiv, null, children)));
};
exports.Card = Card;
